const apiBaseUrl = 'https://apiv2.vestiairecollective.com';
const apiSSRBaseUrl = 'http://vc-prod-atlas.vctools.team';
import { version } from '../../package.json';

export const environment = {
  production: true,
  envName: 'production',
  datadog: {
    enable: false,
    appId: 'c4d3bea0-51a5-4f41-a937-e3258604cada',
    clientToken: 'pubb5a5d86e8d77a774c3306f1349fb64ea',
    service: 'ngx-prod',
    version: `${version}`
  },
  legacyLink: 'https://www.vestiairecollective.com/',
  logLevel: 'warn',
  apiBaseUrl,
  apiSSRBaseUrl,
  apiStaticBaseUrl: 'https://api-static-s3.vestiairecollective.com/',
  algoliaAppId: 'X1KNQWT5F5',
  algoliaApiKey: '150bcaf530a12d03415c0cc8ef1267f8',
  algoliaProxyHost: 'search.vestiairecollective.com',
  checkoutBaseUrl: 'https://checkout.vestiairecollective.com/',
  imagesPath: 'https://images.vestiairecollective.com/cdn-cgi/image/',
  assetsPath: 'https://assets.vestiairecollective.com/',
  designSystemVersion: 'v1',
  svgSpritePath: '/assets/icons/sprite.svg',
  cookieSession: 'EZBO_SESSION_vdclive',
  guestCookie: 'vc_guest',
  cookieOptions: { domain: '.vestiairecollective.com' },
  i18n: {
    hosts: {
      'x-default': 'www.vestiairecollective.com',
      'en-GB': 'www.vestiairecollective.com',
      'en-US': 'us.vestiairecollective.com',
      'fr-FR': 'fr.vestiairecollective.com',
      'de-DE': 'de.vestiairecollective.com',
      'es-ES': 'es.vestiairecollective.com',
      'it-IT': 'it.vestiairecollective.com'
    }
  },
  analytics: { envName: 'prod', verbose: false },
  facebookAppId: '93627932027',
  feature: {
    seller_rating: true,
    usablenet_accessibility: true,
    newsfeed: true,
    free_autentication_for_instock: true,
    chat: true,
    hyperwallet: true,
    journal_main: true,
    chat_from_pdp: true,
    recently_viewed_block: true,
    personalization_filter: true,
    personalization_webview: true,
    checkout_revamp: false,
    qc_report: true,
    enable_my_sizes_on_hp: false,
    professional_sellers_landing: false
  },
  vccmsuri: `${apiBaseUrl}/contents/cms`,
  vccmsimguri: 'https://assets-cms.vestiairecollective.com',
  streamApiKey: '2z32xywf24hh'
};
